var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:{editable:_vm.editing},attrs:{"id":_vm.item.id,"data-fields":"title=txt&body=rte"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"w-50 m-auto text-center"},[_c('h2',[_vm._v(_vm._s(_vm.item.title))]),_c('p',[_vm._v(_vm._s(_vm.item.body))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }